<div class="calculator__inner pb-90">
  <div class="calculator__toggles uslugi">
      <div class="calculator__left-title">Способ оповещения</div>
      <div class="uslugi__area">
        <el-form-item prop="services.smsNotification" class="calculator__toggle">
          <div class="calculator__toggle-title">
            СМС оповещение
            <div class="calculator__toggle-price">20 руб</div>
          </div>
          <el-switch v-model="dataForm.smsNotification" @update:model-value="notificationError = false"/>
        </el-form-item>
        <el-form-item prop="services.returnOfDocuments" class="calculator__toggle">
          <div class="calculator__toggle-title">
            Отслеживать самостоятельно в личном кабинете
            <div class="calculator__toggle-price">Бесплатно</div>
          </div>
          <el-switch @change="" v-model="dataForm.lkNotification" @update:model-value="notificationError = false"/>
        </el-form-item>
        <el-form-item prop="services.returnOfDocuments" class="calculator__toggle">
          <div class="calculator__toggle-title">
            Получить на почту
            <div class="calculator__toggle-price">Бесплатно</div>
          </div>
          <el-switch v-model="dataForm.emailNotification" @update:model-value="notificationError = false"/>
        </el-form-item>
        <p class="block__notice m-0" v-if="dataForm.emailNotification">
          Убедитесь, что email получателя указан верно — на него придет уведомление о прибытии груза.
        </p>
      </div>
      <p class="total-weight--error-bigger" v-if="notificationError">Пожалуйста выберите способ оповещения</p>
    </div>
  <div class="calculateArrow">
    <div class="step-counter">6/{{ dataForm.totalSteps }}</div>
    <div class="arrows-steps-prev" @click="$emit('click-button-back')"></div>
    <div class="arrows-steps-next"
    @click="dataForm.lkNotification || dataForm.emailNotification || dataForm.smsNotification
    ? $emit('click-button-next', [...getArrayOfRules(dataForm.consignee, 'consignee')], true, 'cargo-transportation-customer')
    : notificationError = true">
    </div>
  </div>
</div>

